import axios from "axios"
const apiBaseUrl = process.env.REACT_APP_APIBASE_URL

export const createMonthlyTargetAPI = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/set-monthlyTarget`,
      payload,
      { headers }
    )
    return response
  } catch (error) {
    console.error("Error:", error)
    throw error
  }
}


export const getMonthlyTargetAPI = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/get-monthlyTarget`,
      payload,
      { headers }
    )
    return response
  } catch (error) {
    console.error("Error:", error)
    throw error
  }
}

export const createCompTargetAPI = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/set-CompanyTarget`,
      payload,
      { headers }
    )
    return response
  } catch (error) {
    console.error("Error:", error)
    throw error
  }
}


export const getCompTargetAPI = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/get-COMTarget`,
      payload,
      { headers }
    )
    return response
  } catch (error) {
    console.error("Error:", error)
    throw error
  }
}

export const updateCompTargetAPI = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/update-CompanyTarget`,
      payload,
      { headers }
    )
    return response
  } catch (error) {
    console.error("Error:", error)
    throw error
  }
}

export const getEmpTargetAPI = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/get-EmployeeTarget`,
      payload,
      { headers }
    )
    return response
  } catch (error) {
    console.error("Error:", error)
    throw error
  }
}



export const updateMonthlyTargetAPI = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/update-monthlyTarget`,
      payload,
      { headers }
    )
    return response
  } catch (error) {
    console.error("Error:", error)
    throw error
  }
}


export const createYearlyTargetAPI = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/set-yearlyTarget`,
      payload,
      { headers }
    )
    return response
  } catch (error) {
    console.error("Error:", error)
    throw error
  }
}


export const getYearlyTargetAPI = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/get-yearlyTarget`,
      payload,
      { headers }
    )
    return response
  } catch (error) {
    console.error("Error:", error)
    throw error
  }
}

export const updateyearlyTargetAPI = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/update-yearlyTarget`,
      payload,
      { headers }
    )
    return response
  } catch (error) {
    console.error("Error:", error)
    throw error
  }
}


export const createLOBTargetAPI = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(`${apiBaseUrl}/set-LOBtarget`, payload, {
      headers,
    })
    return response
  } catch (error) {
    console.error("Error:", error)
    throw error
  }
}


export const getLOBTargetAPI = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(`${apiBaseUrl}/get-LOBTarget`, payload, {
      headers,
    })
    return response
  } catch (error) {
    console.error("Error:", error)
    throw error
  }
}


export const updateLOBTargetAPI = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(`${apiBaseUrl}/upadte-LOBtarget`, payload, {
      headers,
    })
    return response
  } catch (error) {
    console.error("Error:", error)
    throw error
  }
}


export const getComMonthlyAPI = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(`${apiBaseUrl}/get-COMmonth`,{}, {
      headers,
    })
    return response
  } catch (error) {
    console.error("Error:", error)
    throw error
  }
}


export const getComYearlyAPI = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(`${apiBaseUrl}/get-COMyear`,{}, {
      headers,
    })
    return response
  } catch (error) {
    console.error("Error:", error)
    throw error
  }
}


export const getLobMonthlyAPI = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(`${apiBaseUrl}/get-LOBmonth`,{}, {
      headers,
    })
    return response
  } catch (error) {
    console.error("Error:", error)
    throw error
  }
}



export const getLobYearlyAPI = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(`${apiBaseUrl}/get-LOByear`,{}, {
      headers,
    })
    return response
  } catch (error) {
    console.error("Error:", error)
    throw error
  }
}



export const getYearlyChartAPI = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(`${apiBaseUrl}/speedomater-year`,{}, {
      headers,
    })
    return response
  } catch (error) {
    console.error("Error:", error)
    throw error
  }
}


export const getMonthlyChartAPI = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(`${apiBaseUrl}/speedomater-month`,{}, {
      headers,
    })
    return response
  } catch (error) {
    console.error("Error:", error)
    throw error
  }
}
